// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-table.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:first-child {\n  padding-left: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
